import { io, type Socket } from "socket.io-client";
import { WS_EVENTS } from "@opus-dt/shared-types";
import { api } from "./api-client";

let socket: Socket | null = null;

// Assinatura para "o singleton do socket mudou" (criado/destruído).
// Resolve a ordenação de efeitos: consumidores descendentes (ex.: RealtimeBadge,
// montado dentro do Topbar) têm seu efeito ANTES do efeito que cria o socket no
// AppLayout. Sem este sinal, eles veriam getSocket()===null e nunca religariam.
const socketChangeListeners = new Set<() => void>();

export function onSocketChange(listener: () => void): () => void {
  socketChangeListeners.add(listener);
  return () => {
    socketChangeListeners.delete(listener);
  };
}

function emitSocketChange(): void {
  for (const listener of socketChangeListeners) listener();
}

export function connectWs(): Socket {
  if (socket) {
    if (!socket.connected) socket.connect();
    return socket;
  }
  socket = io({
    path: "/socket.io",
    // `auth` como FUNÇÃO: o socket.io a chama a cada (re)conexão, então o handshake
    // sempre usa o token MAIS RECENTE — incluindo o refresh silencioso do api-client,
    // que atualiza só o token de módulo e NÃO passa pelo auth store. Sem isto, uma
    // reconexão após expiração reautenticaria com JWT vencido e entraria em loop. (#3)
    auth: (cb: (data: Record<string, unknown>) => void) =>
      cb({ token: api.getAccessToken() ?? "" }),
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
  emitSocketChange();
  return socket;
}

export function disconnectWs(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
    emitSocketChange();
  }
}

export function joinLine(lineId: string): void {
  socket?.emit(WS_EVENTS.JOIN_LINE, { lineId });
}

export function leaveLine(lineId: string): void {
  socket?.emit(WS_EVENTS.LEAVE_LINE, { lineId });
}

export function getSocket(): Socket | null {
  return socket;
}
